/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_push.js                                                                           */
/**********************************************************************************************************************/
/* Subscriptions Custom */
HafasWebapp.prototype.subscriptions.Push = function (_me) {
  Hafas.ps.sub('/push/setupAlarmType', Hafas.bind(_me.Controller.Push.setupAlarmType, _me));

  /* Subscription actions */
  Hafas.ps.sub('/push/news', Hafas.bind(_me.Controller.Push.showMessages,_me));
  Hafas.ps.sub('/push/details', Hafas.bind(_me.Controller.Push.showDetails,_me));
  Hafas.ps.sub('/push/alternatives', Hafas.bind(_me.Controller.Push.showAlternatives,_me));
  Hafas.ps.sub('/push/edit', Hafas.bind(_me.Controller.Push.showEditDialog,_me));
  Hafas.ps.sub('/push/delete', Hafas.bind(_me.Controller.Push.deleteSubscription,_me));
  Hafas.ps.sub('/push/deleteSubscrConfirmation', Hafas.bind(_me.Controller.Push.deleteSubscrConfirmation,_me));
  Hafas.ps.sub('/push/save', Hafas.bind(_me.Controller.Push.saveSubscription,_me));
  Hafas.ps.sub('/push/showMoreNotifications', Hafas.bind(_me.Controller.Push.showMoreNotifications,_me))
  Hafas.ps.sub('/push/acceptRepeat', Hafas.bind(_me.Controller.Push.acceptRepeatOptions,_me));
  Hafas.ps.sub("/push/updateWeekdaySelection", Hafas.bind(_me.Controller.Push.updateWeekdaySelection,_me));
  Hafas.ps.sub("/push/pauseAlarms", Hafas.bind(_me.Controller.Push.pauseAlarms,_me));
  Hafas.ps.sub("/push/pauseAllSubscriptions", Hafas.bind(_me.Controller.Push.pauseAllSubscriptions,_me));
  Hafas.ps.sub("/push/revitalizeUserId", Hafas.bind(_me.Controller.Push.revitalizeUserId,_me));
  Hafas.ps.sub('/push/deleteUser', Hafas.bind(_me.Controller.Push.deleteUser,_me));
  Hafas.ps.sub('/push/showConnDetails', Hafas.bind(_me.Controller.Push.showConnDetails,_me));
  Hafas.ps.sub('/push/logOutFromMailDialog', Hafas.bind(_me.Controller.Push.logOutFromMailDialog,_me));
  Hafas.ps.sub('/push/logOutFromMail', Hafas.bind(_me.Controller.Push.logOutFromMail,_me));
  Hafas.ps.sub('/push/setSaveBtnDisabled', Hafas.bind(_me.Controller.Push.setSaveBtnDisabled,_me));
  Hafas.ps.sub('/push/updateSubscrStatus', Hafas.bind(_me.Controller.Push.updateSubscriptionStatus,_me));

  // Aboeinstellungen
  Hafas.ps.sub('/push/resendAccountInfo', Hafas.bind(_me.Controller.Push.resendAccountInfo,_me));
  Hafas.ps.sub('/push/confirmChannel', Hafas.bind(_me.Controller.Push.confirmChannel,_me));
  Hafas.ps.sub('/push/confirmResendAccountInfo', Hafas.bind(_me.Controller.Push.confirmResendAccountInfo,_me))
  Hafas.ps.sub('/push/deleteUserData', Hafas.bind(_me.Controller.Push.deleteUserDialog,_me));
  Hafas.ps.sub('/push/deleteUserConfirmation', Hafas.bind(_me.Controller.Push.deleteUserConfirmation,_me));
  Hafas.ps.sub('/push/closeInfoPopup', Hafas.bind(_me.Controller.Push.closeInfoPopup,_me));
  Hafas.ps.sub('/push/changeNotificationOption', Hafas.bind(_me.Controller.Push.changeNotificationOption,_me));
  Hafas.ps.sub('/push/changeDelayOption', Hafas.bind(_me.Controller.Push.changeDelayOption,_me));

  Hafas.ps.sub('/push/sendLoginLinkPopup', Hafas.bind(_me.Controller.Push.sendLoginLinkPopup,_me));

  Hafas.ps.sub('/push/createOrLoginUser', Hafas.bind(_me.Controller.Push.createOrLoginUser,_me));

  Hafas.ps.sub('/push/setLoginState', Hafas.bind(_me.Controller.Push.setLoginState,_me));

  Hafas.ps.sub('/push/selectChannel', Hafas.bind(_me.Controller.Push.selectChannel, _me));
  Hafas.ps.sub('/push/validateChannelInput', Hafas.bind(_me.Controller.Push.validateChannelInput, _me));

  Hafas.ps.sub('/push/showInfoPopup', Hafas.bind(_me.Controller.Push.showInfoPopup,_me));

  Hafas.ps.sub('/GUI/closeView/Push', Hafas.bind(_me.Controller.Push.closeView,_me));
  Hafas.ps.sub('/GUI/restoreView/Push', Hafas.bind(_me.Controller.Push.restoreView,_me));

  Hafas.ps.sub('/push/setWebpushAddress', Hafas.bind(_me.Controller.Push.setWebpushAddress, _me));

  // TP Modul wird verlassen
  Hafas.ps.sub('/GUI/leaveContext/Push', Hafas.bind(_me.Controller.Push.cleanup, _me));
};

